export default __webpack_public_path__ + "static/media/html.2b2e078a.svg";